import styled from 'styled-components'

import { Icon } from './'

interface WrapperProps {
  size: number
}

const Wrapper = styled.div<WrapperProps>`
  /* css */
  color: #000000;
  display: inline-block;
  font-size: ${(props: WrapperProps) => props.size}px;
  font-weight: ${(props: WrapperProps) => (props.size >= 16 ? 700 : 500)};
  [class^='Icon'] {
    color: #ffd267;
  }
`

interface Props {
  rating: number
  size: number
}

const Rating: React.FC<Props> = (props: Props) => {
  return (
    <Wrapper size={props.size}>
      <Icon name="star" size={props.size} /> {props.rating}
    </Wrapper>
  )
}

export default Rating
